import axios from '@/axios'

const service = {
  //投诉建议提交
  async suggestionSub(params) {
    return await axios.post('/uc/api/servicecenter/advise', params, { des: '直客pc投诉建议提交', sTime: new Date().getTime() })
  },
  //投诉建议列表
  async getSuggesList(params) {
    return await axios.get('/uc/api/servicecenter/advise', params, { des: '直客pc投诉建议列表', sTime: new Date().getTime() })
  },
  //我的消息列表
  async getMymsgList(params) {
    return await axios.post('/uc/user/notice/list', params, { des: '直客pc我的消息列表', sTime: new Date().getTime() })
  },
  //获取消息列表详情
  async getListDetail(params) {
    return await axios.post('/uc/user/notice/detail', params, { des: '直客pc获取消息列表详情', sTime: new Date().getTime() })
  }
}

export default service


// WEBPACK FOOTER //
// ./src/api/service.js